import { requestApi } from 'api/Api';

export const getFacilityProvider = async (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/practice/facility/read',
    onError: () => {},
    params
  });
};

export const upsertFacilityProvider = async (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/practice/facility/upsert',
    onError: () => {},
    params
  });
};

export const deleteFacilityProvider = async (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/practice/facility/delete',
    onError: () => {},
    params
  });
};

export const getBillingProvider = async (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/practice/billing/read',
    onError: () => {},
    params
  });
};

export const upsertBillingProvider = async (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/practice/billing/upsert',
    onError: () => {},
    params
  });
};

export const deleteBillingProvider = async (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/practice/billing/delete',
    onError: () => {},
    params
  });
};
